// extracted by mini-css-extract-plugin
export var hidden = "menu-module--hidden--2yqMm";
export var menu = "menu-module--menu--d_JCx";
export var logo = "menu-module--logo--QC1QV";
export var navlogo = "menu-module--navlogo--2Z2Vt";
export var nav = "menu-module--nav--3_n6R";
export var navMenu = "menu-module--navMenu--1QMhW";
export var resumeButton = "menu-module--resumeButton--3XQkv";